<template>
  <div class="lesson-header">
    <!-- Cover image -->
    <div class="cover">
      <img v-if="coverImage" :src="coverImage" class="cover-img" :alt="lessonTitle">
      <div class="cover-overlay" />

      <!-- Breadcrumb поверх зображення -->
      <div class="cover-nav lg:px-48 md:px-12 px-4">
        <nav class="font-montserrat text-sm text-white/60 flex items-center gap-2">
          <NuxtLink :to="localePath('/')" class="hover:opacity-100 transition-opacity text-white">
            {{ t('lesson.breadcrumbHome') }}
          </NuxtLink>
          <span>/</span>
          <span>{{ t('lesson.breadcrumbLessons') }}</span>
        </nav>
      </div>
    </div>

    <!-- Floating card -->
    <div class="card-wrap lg:px-48 md:px-12 px-4">
      <div class="card">
        <p class="font-montserrat text-xs uppercase tracking-widest text-gray-400 mb-3">
          {{ t('lessons.lesson') }} {{ lessonOrder }}
        </p>
        <h1 class="font-pt-serif text-4xl md:text-5xl font-bold leading-tight">
          {{ lessonTitle }}
        </h1>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { COURSE_CONFIG } from '~/config/course'

defineProps<{
  lessonTitle: string
  lessonOrder: number
  coverImage?: string | null
}>()

const { t } = useI18n()
const localePath = useLocalePath()
const courseTitle = COURSE_CONFIG.title
</script>

<style scoped>
.lesson-header {
  width: 100%;
  background-color: #F4F2ED;
}

.cover {
  position: relative;
  width: 100%;
  height: 70vh;
  min-height: 400px;
  overflow: hidden;
}

.cover-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.cover-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(0,0,0,0.75) 0%,
    rgba(0,0,0,0.0) 45%,
    rgba(0,0,0,0.15) 100%
  );
}

.cover-nav {
  position: absolute;
  top: 7rem;
  left: 0;
  right: 0;
  z-index: 2;
}

.card-wrap {
  position: relative;
  z-index: 2;
  margin-top: -4rem;
}

.card {
  background-color: #F4F2ED;
  border-radius: 1.5rem 1.5rem 0 0;
  padding: 2.5rem 3rem;
  box-shadow: 0 -8px 20px rgba(0,0,0,0.06);
  clip-path: inset(-30px -20px 0px -20px);
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

@media (max-width: 768px) {
  .cover { height: 55vw; min-height: 280px; }
  .card { padding: 2rem 1.5rem; border-radius: 1rem 1rem 0 0; }
  .card-wrap { margin-top: -2rem; }
}
</style>
